<template>
  <el-dropdown trigger="click" @command="handleCommand" class="language-switch">
    <span class="switcher" :title="currentLang.label">
      <img v-if="currentLang.flag" :src="currentLang.flag" class="lang-flag" />
      <span class="lang-code">{{ currentLang.header }}</span>
      <i class="el-icon-arrow-down"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item in languages"
        :key="item.key"
        :command="item.key"
        :class="{ 'is-active': locale === item.key }">
        <img v-if="item.flag" :src="item.flag" class="lang-flag-inline" />
        <span>{{ item.label }}</span>
        <span class="lang-code-inline">{{ item.header }}</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import ElementUI from 'element-ui'
import i18n from '@/locales'
import { getCurrentLocale, setLocale, getSupportedLanguages } from '@/utils/i18n'
import { Message } from 'element-ui'
import EventBus from '@/utils/eventBus'
import { listAllEnabled } from '@/api/languageCode'

export default {
  name: 'LanguageSwitch',
  data() {
    return {
      locale: getCurrentLocale(),
      languages: getSupportedLanguages()
    }
  },
  computed: {
    currentLang() {
      const item = this.languages.find(l => l.key === this.locale)
      return item || { key: this.locale, header: this.locale, label: this.locale, flag: '' }
    }
  },
  created() {
    i18n.locale = this.locale
    this.loadLanguages()
  },
  methods: {
    loadLanguages() {
      listAllEnabled().then(res => {
        const list = res.data || []
        if (list.length > 0) {
          this.languages = list.map(item => {
            return {
              key: item.lang,
              lang: item.lang,
              header: item.shortCode || item.lang,
              label: item.languageName || item.country || item.lang,
              flag: item.icon || ''
            }
          })
        }
      }).catch(() => {})
    },
    handleCommand(key) {
      if (key === this.locale) return
      this.locale = key
      setLocale(key)
      i18n.locale = key
      const elementLocale = this.getElementLocale(key)
      if (elementLocale) {
        ElementUI.locale = elementLocale
      }
      Message.success('语言已切换')
      // 通过事件总线通知所有页面：语言已切换，请重新加载数据
      EventBus.$emit('language-changed', key)
    },
    getElementLocale(vueI18nKey) {
      const map = {
        'zh-CN': require('element-ui/lib/locale/lang/zh-CN'),
        'en-US': require('element-ui/lib/locale/lang/en'),
        'vi-VN': require('element-ui/lib/locale/lang/vi')
      }
      return map[vueI18nKey] || null
    }
  }
}
</script>

<style lang="scss" scoped>
.language-switch {
  .switcher {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 12px;
    height: 50px;
    font-size: 14px;
    color: #fff;
    &:hover { background: rgba(255,255,255,0.08); }
    .lang-flag {
      width: 20px;
      height: 14px;
      margin-right: 6px;
      border-radius: 2px;
      object-fit: cover;
    }
    .lang-code { margin-right: 6px; font-weight: 500; }
  }
  .el-dropdown-menu {
    .lang-flag-inline {
      width: 20px;
      height: 14px;
      margin-right: 6px;
      border-radius: 2px;
      object-fit: cover;
      vertical-align: middle;
    }
    .lang-code-inline {
      float: right;
      color: #909399;
      font-size: 12px;
    }
    .is-active { color: #409EFF; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LanguageSwitch/index.vue